export default state => state.bus.userConfig.providerId;
